var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00157 1C7.52939 1 7.03896 1.5419 7.05001 2V8C7.04252 8.52831 7.47233 9 8.00157 9C8.5308 9 8.96061 8.52831 8.95312 8V2C8.96777 1.3949 8.47374 1 8.00157 1ZM4.65228 3.5C4.56495 3.51929 4.48037 3.55096 4.40187 3.59375C1.39745 5.16525 0.477045 8.39165 1.27175 11.0625C2.06645 13.7325 4.55703 15.9995 7.97021 15.9995C11.3349 15.9995 13.8571 13.8505 14.7004 11.2185C15.5428 8.58645 14.6423 5.39515 11.5703 3.62455C11.1356 3.37095 10.5096 3.53465 10.2552 3.96825C10.0011 4.40185 10.165 5.02715 10.5997 5.28075C12.9944 6.66055 13.4869 8.77515 12.8847 10.6558C12.2825 12.5364 10.5368 14.0933 7.97041 14.0933C5.39029 14.0933 3.66577 12.443 3.08742 10.4994C2.50887 8.55595 3.04034 6.45145 5.27831 5.28075C5.65763 5.07445 5.85836 4.58825 5.73485 4.17505C5.61145 3.76175 5.17674 3.46475 4.74624 3.49955C4.71488 3.49805 4.68353 3.49805 4.65228 3.49955V3.5Z",
    fill: "#2514BE",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSwitch);
export default __webpack_public_path__ + "static/media/power-switch.ee47a6e0934cfc02a8e707b07c729507.svg";
export { ForwardRef as ReactComponent };